var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 57,
    viewBox: "0 0 68 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8924 6.55664H8.04626C5.9713 6.55664 4.28955 8.23839 4.28955 10.3133V17.8268H61.8924V6.55664Z",
    fill: "#E2D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8923 4.44421C61.8923 2.36925 60.2106 0.6875 58.1356 0.6875C52.8399 0.6875 43.2929 0.6875 38.5018 0.6875C36.7049 0.6875 35.0444 1.65047 34.1528 3.21076C32.6739 5.80038 30.5864 9.45315 30.5864 9.45315H61.8923V4.44421Z",
    fill: "#E2D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28955 10.0767H61.8924V12.4096H4.28955V10.0767Z",
    fill: "#AA7CFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1099 17.3059C66.309 15.8708 65.877 14.4195 64.9265 13.3275C63.9748 12.2343 62.5974 11.6069 61.1485 11.6069C48.3807 11.6069 17.8011 11.6069 5.03334 11.6069C3.5845 11.6069 2.20704 12.2343 1.25534 13.3275C0.304892 14.4195 -0.12713 15.8708 0.0719758 17.3059C1.34174 26.4472 3.80614 44.1889 4.94192 52.3685C5.28629 54.8441 7.40257 56.6874 9.90328 56.6874H56.2786C58.7793 56.6874 60.8956 54.8441 61.24 52.3685C62.3757 44.1889 64.8401 26.4472 66.1099 17.3059Z",
    fill: "#E2D5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.492727 20.3363C0.586645 19.2932 1.00489 18.2964 1.70489 17.4924C2.65534 16.4005 4.0328 15.7731 5.48164 15.7731H60.7002C62.1491 15.7731 63.5265 16.4005 64.477 17.4924C65.177 18.2964 65.5952 19.2932 65.6892 20.3363L66.1099 17.3059C66.309 15.8708 65.877 14.4195 64.9265 13.3275C63.9748 12.2343 62.5974 11.6069 61.1485 11.6069C48.3807 11.6069 17.8011 11.6069 5.03334 11.6069C3.5845 11.6069 2.20704 12.2343 1.25534 13.3275C0.304892 14.4195 -0.12713 15.8708 0.0719758 17.3059L0.492727 20.3363Z",
    fill: "#EFE9FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.457 44.1978C27.457 42.8154 26.3363 41.6934 24.9525 41.6934C22.1738 41.6934 17.7146 41.6934 14.9346 41.6934C13.5522 41.6934 12.4302 42.8154 12.4302 44.1978V46.7023C12.4302 48.086 13.5522 49.2068 14.9346 49.2068H24.9525C26.3363 49.2068 27.457 48.086 27.457 46.7023C27.457 45.8971 27.457 45.0043 27.457 44.1978Z",
    fill: "#9B5AF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2393 20.6733C38.9826 20.6733 33.0908 26.5651 33.0908 33.8218C33.0908 41.0785 38.9826 46.9703 46.2393 46.9703C53.496 46.9703 59.3878 41.0785 59.3878 33.8218C59.3878 26.5651 53.496 20.6733 46.2393 20.6733ZM46.2393 24.43C51.4223 24.43 55.6311 28.6388 55.6311 33.8218C55.6311 39.0048 51.4223 43.2136 46.2393 43.2136C41.0563 43.2136 36.8475 39.0048 36.8475 33.8218C36.8475 28.6388 41.0563 24.43 46.2393 24.43Z",
    fill: "#9B5AF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.088 42.9017L64.7688 54.5826C65.5027 55.3164 66.6923 55.3164 67.4261 54.5826C68.1586 53.85 68.1586 52.6591 67.4261 51.9266L55.7452 40.2457C55.0114 39.5131 53.8218 39.5131 53.088 40.2457C52.3554 40.9783 52.3554 42.1691 53.088 42.9017Z",
    fill: "#9B5AF8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.6bbbade73abc316cb50f4411e7b601a6.svg";
export { ForwardRef as ReactComponent };